import { useState } from "react";
import {
  Container, Row, Col, Button, Dropdown, Form, Table, Badge, ButtonGroup
} from "react-bootstrap";
import { ThreeDots } from "react-bootstrap-icons"; 


import Header from "../../components/header";
import Footer from "../../components/footer";


export default function ContactsInfo() {
  const [query, setQuery] = useState("");
  const [sort, setSort] = useState("Last Updated");

  const contacts = []; // plug your data here

  const filtered = contacts.filter(c =>
    [c.name, c.phone, c.source].join(" ").toLowerCase().includes(query.toLowerCase())
  );

  return (
  <div className="min-vh-100 d-flex flex-column">
    {/* Top Navbar */}
    <Header/>
      <section className="hero">
 <Container fluid className="py-4 bg-light min-vh-100 bg-fffaed bg-opacity-10 rounded-3 text-center p-4 mt-5 mx-auto">
      {/* Header */}
      <Row className="align-items-center g-3 mb-3">
        <Col xs="12" md="6">
          <h1 className="mb-0 h1 hero-family">Contacts</h1>
          <small className="text-muted">
            Contact list stores the numbers you’ve interacted with.
          </small>
        </Col>
        <Col xs="12" md="6" className="d-flex justify-content-md-end gap-2">
          <Button variant="success">+ Add Contact</Button>
        </Col>
      </Row>

      {/* Controls */}
      <Row className="g-2 align-items-stretch mb-3">
        <Col xs={12} md="auto">
          <Dropdown as={ButtonGroup}>
            <Button variant="outline-secondary">{sort}</Button>
            <Dropdown.Toggle split variant="outline-secondary" />
            <Dropdown.Menu>
              {["Last Updated", "Name (A–Z)", "Newest"].map(opt => (
                <Dropdown.Item key={opt} onClick={() => setSort(opt)}>
                  {opt}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </Col>

        <Col xs={12} md>
          <Form.Control
            placeholder="Search…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </Col>

        <Col xs="auto" className="d-flex gap-2 ms-md-auto">
          <Button variant="outline-secondary">Export</Button>
          <Button variant="outline-secondary">Import</Button>
          <Button variant="outline-success">
            <ThreeDots />
          </Button>
        </Col>
      </Row>

      {/* Table (responsive) */}
      <div className="bg-white rounded-3 p-2 shadow-sm">
        <Table hover responsive="md" className="mb-0 align-middle">
          <thead className="text-muted">
            <tr>
              <th>Basic info</th>
              <th className="d-none d-md-table-cell">Phone number</th>
              <th className="d-none d-lg-table-cell">Source</th>
              <th className="d-none d-lg-table-cell">Contact Attributes</th>
              <th className="text-end">Edit/Delete</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan={5} className="py-5 text-center text-muted">
                  No contacts yet.
                </td>
              </tr>
            ) : (
              filtered.map((c) => (
                <tr key={c.id}>
                  <td>
                    <div className="fw-medium">{c.name}</div>
                    <div className="text-muted small">{c.label}</div>
                  </td>
                  <td className="d-none d-md-table-cell">{c.phone}</td>
                  <td className="d-none d-lg-table-cell">{c.source}</td>
                  <td className="d-none d-lg-table-cell">
                    {c.tags?.map(t => <Badge key={t} bg="light" text="dark" className="me-1">{t}</Badge>)}
                  </td>
                  <td className="text-end">
                    <Button size="sm" variant="outline-secondary" className="me-2">Edit</Button>
                    <Button size="sm" variant="outline-danger">Delete</Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      {/* Footer */}
      <Row className="mt-2 align-items-center">
        <Col className="text-muted small">Rows per page:
          <span className="ms-2 fw-semibold">5</span>
        </Col>
        <Col className="text-end">
          <Button variant="link" className="text-decoration-none">Previous</Button>
          <Button variant="link" className="text-decoration-none">Next</Button>
        </Col>
      </Row>
    </Container>
      </section>
      {/* Footer Note */}
      <Footer/>
    </div>
  );
}
